import {
  Divider,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  Modal,
  ModalClose,
  ModalDialog,
  Stack,
  Typography,
} from '@healthinal/ui';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { MedicationDto } from '../../../../api/generated/model';
import { FormActionButtons } from '../../../../components/form/FormActionButtons.tsx';

interface FormValues {
  name: string;
}

export function CreateMedicationDialog({
  open,
  onClose,
  currentMedications,
  medication,
  isLoading,
}: {
  open: boolean;
  onClose: (medication?: MedicationDto) => void;
  currentMedications: MedicationDto[];
  medication?: MedicationDto | null;
  isLoading?: boolean;
}) {
  const isEditing = !!medication?.id;

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors, isDirty: isFormDirty },
  } = useForm<FormValues>({ defaultValues: { name: '' } });

  const handleOnClose = () => {
    reset();
    onClose();
  };

  useEffect(() => {
    if (open) {
      reset({ name: medication?.name ?? '' });
    }
  }, [open, medication, reset]);

  return (
    <Modal open={open} onClose={handleOnClose}>
      <ModalDialog sx={{ width: 500 }}>
        <ModalClose />
        <Typography level={'h4'}>{isEditing ? 'Dieses Medikament bearbeiten' : 'Medikament erstellen'}</Typography>
        <Divider />
        <form
          onSubmit={(event) => {
            event.stopPropagation();
            void handleSubmit((data) => {
              if (isEditing && medication?.id) {
                onClose({ id: medication.id, name: data.name, isActive: medication.isActive });
              } else {
                onClose({ name: data.name, isActive: true });
              }
            })(event);
          }}>
          <Stack gap={2}>
            <FormControl error={!!errors.name}>
              <FormLabel>
                <Typography>Medikament</Typography>
              </FormLabel>
              <Input
                {...register('name', {
                  required: true,
                  validate: (name) =>
                    !currentMedications.some((med) => med.name === name && med.id !== medication?.id),
                })}
              />
              {errors.name && (
                <FormHelperText>
                  {errors.name.type === 'required' ? 'Name muss ausgefüllt werden' : 'Medikament existiert bereits'}
                </FormHelperText>
              )}
            </FormControl>
            <FormActionButtons onAbortClick={handleOnClose} disableSubmit={!isFormDirty} isLoading={isLoading} />
          </Stack>
        </form>
      </ModalDialog>
    </Modal>
  );
}
